import { render, staticRenderFns } from "./iconAmericanExpress.vue?vue&type=template&id=7dd5ae66"
import script from "./iconAmericanExpress.vue?vue&type=script&lang=js"
export * from "./iconAmericanExpress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports